import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.sidebar');
import { OnInit } from '@angular/core';
import { HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.sidebar/view.scss */
:host {
  display: block;
  height: 100%;
}

.dashboard-layout {
  background: #fbfdfd;
}

.dashboard-shell .sidebar-surface {
  border-right: 1px solid #e6ebee;
  background: #fff !important;
  box-shadow: 8px 0 28px rgba(41, 62, 74, 0.035);
}

@media (min-width: 1024px) {
  .dashboard-shell .app-sidebar {
    width: 230px !important;
  }
  .dashboard-shell .app-content {
    padding-left: 230px !important;
  }
}`],
})
export class LayoutSidebarComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.service.status.toggle('navbar', true);
    }

    @HostListener('document:click')
    public clickout() {
        this.service.status.toggle('navbar', true);
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0
    }

    public get isDashboard() {
        return location.pathname === "/" || location.pathname.indexOf("/dashboard") === 0;
    }
}

export default LayoutSidebarComponent;